import styles from './solid-button.module.css';
import { Button } from '@radix-ui/themes';

interface Props extends React.ComponentProps<typeof Button> {
  children: React.ReactNode;
}

const SolidButton = ({ children, ...props }: Props) => {
  return (
    <Button
      {...props}
      className={styles.ContrastButton}
    >
      {children}
    </Button>
  );
};

export default SolidButton;
